<template>
  <div>
    <el-container>
      <el-header>
        <div>
          <el-button type="primary" @click="updateApplets()" size="small">更新小程序</el-button>
        </div>
      </el-header>
      <el-main>
        <template>
          <el-table
            :data="tableData"
            border
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              fixed
              prop="corpid"
              label="corpid"
              width="300">
            </el-table-column>
            <el-table-column
              prop="corpsecret"
              label="corpsecret"
              width="280">
            </el-table-column>
            <el-table-column
              prop="agentId"
              label="agentId"
              width="280">
            </el-table-column>
            <el-table-column
              prop="create_time"
              :formatter="formatTime"
              label="创建时间"
              width="220">
            </el-table-column>
            <el-table-column
              prop="update_time"
              :formatter="formatTime"
              label="最后修改时间"
              width="220">
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-button @click="updateEW(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-footer>
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  import apiController from '@/api/applets'
  export default {
    name: 'applets',
    data(){
      return {
        tableData:[],
        allcount0:0,//总页数 对应 total
        count0:100,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        divHeight:500,
      }
    },
    components: {
    },
    created(){
    },
    methods:{
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy-MM-dd hh:mm:ss";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      updateApplets: async function(){
        await apiController.updateApplets({
          params:{
          }
        })
          .then(res => {
            console.log(res)
            let { data, code } = res.data
            if (code === 'Success'){
            }
          })
          .catch((error) => {
            this.$message.error(JSON.stringify(error));
          })
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.isAjax();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.isAjax();
      },
      isAjax: async function(){
        await apiController.getApplets({
          params:{
            limit: this.count0,
            page: this.currentPage0
          }
        })
          .then(res => {
            console.log(res)
            let { data, code } = res.data
            if (code === 'Success'){
              this.tableData = data
            }
          })
          .catch((error) => {
            this.$message.error(JSON.stringify(error));
          })
      },
    },
    mounted(){
      this.isAjax()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/main/applets.vue